/**
 *
 * Marketo Form
 *
 * Submit Marketo form using the Marketo API
 */
jQuery(function ($) {
    $(document).ready(function () {
        $('.js-itbl-signup-form').on('submit', function (e) {
            e.preventDefault();
            let that = $(this);

            let data = that.serialize();
            window.marketoSubmit(data, null)
              .then(successCB)
              .catch(function () {
                  console.log('marketoSubmit failed');
              });

            function successCB() {
                that[0].reset();
                $('.itbl-reveal-overlay').css({ 'display': 'block' }).animate({ 'opacity': 1 }, 'fast');
                $('.itbl-reveal-overlay > .reveal').css({ 'display': 'block' }).animate({ 'top': '100px' });
                $('body').css({ 'overflow': 'hidden' });
                setTimeout(function () {
                    $('.itbl-reveal-overlay').animate({ 'opacity': 0 }, 'fast', function () { $(this).css({ 'display': 'none' }) });
                    $('.itbl-reveal-overlay > .reveal').animate({ 'top': '-100px' }, 'fast', function () { $(this).css({ 'display': 'none' }) });
                    $('body').css({ 'overflow': 'initial' });
                }, 3000);
            }
        });

        //had to make another function call because we have same form at two places
        $('.js-itbl-signup-form-v2').on('submit', function (e) {
            e.preventDefault();
            let that = $(this);

            let data = that.serialize();

            window.marketoSubmit(data, null)
              .then(successCB)
              .catch(function () { console.log('marketoSubmit failed'); });

            function successCB() {
                that[0].reset();
                $('.itbl-reveal-overlay-v2').css({ 'display': 'block' }).animate({ 'opacity': 1 }, 'fast');
                $('.itbl-reveal-overlay-v2 > .reveal').css({ 'display': 'block' }).animate({ 'top': '100px' });
                $('body').css({ 'overflow': 'hidden' });
                setTimeout(function () {
                    $('.itbl-reveal-overlay-v2').animate({ 'opacity': 0 }, 'fast', function () { $(this).css({ 'display': 'none' }) });
                    $('.itbl-reveal-overlay-v2 > .reveal').animate({ 'top': '-100px' }, 'fast', function () { $(this).css({ 'display': 'none' }) });
                    $('body').css({ 'overflow': 'initial' });
                }, 3000);
            }
        });
    });
});
